import { jsx } from "react/jsx-runtime";
import { Box, TextButton } from "@zillow/constellation";
import { yieldCallback } from "@zillow/yield-callback";
import "react";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { usePageProps } from "../PagePropsProvider/PagePropsProvider.esm.js";
import { sendEvent } from "./B2BMainNav.utils.esm.js";
import DropdownMenu from "./DropdownMenu.esm.js";
const DropdownMenuItem = ({
  item,
  sx
}) => {
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const handleItemClick = (item2) => {
    sendEvent("cms_anchor", item2.label, item2.url, cmsInfo);
  };
  return /* @__PURE__ */ jsx(Box, { as: "li", sx: {
    fontFamily: "$fonts.sansSerif",
    lineHeight: "$lineHeights.body",
    ...sx
  }, children: /* @__PURE__ */ jsx(TextButton, { as: "a", fontType: "bodySmall", href: item.url, target: item.target, rel: item.target === "_blank" ? "noopener noreferrer" : void 0, onClick: yieldCallback(() => {
    handleItemClick(item);
  }), children: item.label }) });
};
const Dropdown = ({
  submenus,
  dropdown
}) => {
  return /* @__PURE__ */ jsx(DropdownMenu, { isOpen: dropdown, children: submenus.map((submenu, index) => /* @__PURE__ */ jsx(DropdownMenuItem, { item: submenu, sx: {
    padding: "$spacing.xs $spacing.sm",
    ":hover, :focus": {
      color: "$colors.textDark",
      backgroundColor: "$colors.backgroundBlue"
    }
  } }, index)) });
};
export {
  Dropdown as default
};
